module.exports = __webpack_public_path__ + "img/icon-fontsize-yellow2.779e740b.svg";